import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import withStyles from "components/with-styles";
import styles from "../styles/source-data.css.js";
import { SimpleButton } from "components/buttons";
import { TextDisplay } from "components/display-data";
import OptionalDate from "components/optional-date";
import { Restricted, permissions } from "components/auth";

const StatusData = ({ classes, source, intl, onCheckStatus }) => {
  return (
    <>
      <DataGrid>
        <DataGridItem>
          <OptionalDate label={intl.formatMessage({ id: "common.status.lastChecked" })} value={source.lastChecked} />
        </DataGridItem>
        <DataGridItem>
          <TextDisplay label={intl.formatMessage({ id: "common.status.lastStatus" })}>{source.lastStatus}</TextDisplay>
        </DataGridItem>
      </DataGrid>
      <DataGrid>
        <DataGridItem>
          <OptionalDate label={intl.formatMessage({ id: "common.status.lastStatusOk" })} value={source.lastStatusOk} />
        </DataGridItem>
        <DataGridItem>
          <OptionalDate label={intl.formatMessage({ id: "common.status.lastStatusKo" })} value={source.lastStatusKo} />
        </DataGridItem>
        <Restricted permissions={[permissions.admin_view]}>
          <DataGridItem big>
            <SimpleButton
              onClick={onCheckStatus}
              icon="playlist-add-check"
              label={intl.formatMessage({ id: "source.operations.checkStatus" })}
            />
          </DataGridItem>
        </Restricted>
      </DataGrid>
    </>
  );
};

StatusData.propTypes = {
  /**
   * Data to represent
   **/
  source: PropTypes.object,
  /**
   * Callback que se invoca al clicar el botón de checkear el estado de la cámara
   **/
  onCheckStatus: PropTypes.func,
};

export default injectIntl(withStyles(styles)(StatusData));
